<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-alert id="showAlert" class="d-none" style="border-radius: 20px; margin: 0 10px;">
                Sorry, loading temporary not working, we try to fix it. Please contact our chat 24/7 for split likes.
            </v-alert>
            <v-flex class="pr-lg-1" xs12 v-if="socialNetworkLoaded && socialNetwork.name === 'Instagram'">
                <v-card
                    color="#D8E2F4"
                    class="channels_card ma-2 ma-sm-3 mb-6"
                    elevation="0"
                >
                    <v-row class="d-block d-lg-flex align-center card_title">
                        <v-expansion-panels flat v-model="panel" multiple>
                            <v-expansion-panel>
                                <InstagramCardHeader :social-network="socialNetwork" :scores="$store.getters.instagramScores"/>
                                <InstagramCardContent :accounts="socialNetwork.accounts" :scores="$store.getters.instagramScores" :single-data="singleData" />
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-row>
                </v-card>
            </v-flex>
            <v-flex v-else class="pr-lg-1" xs12>
              <v-posts-loader  :active="'active'" :st="'height: 100px; '" class="row"></v-posts-loader>
            </v-flex>

            <v-flex
                class="mt-4"
                xs12
                sm6
                lg4
                v-for="(post, index) in posts"
                :key="index"
            >
                <InstagramPostCard :post="post" :scores="$store.getters.instagramScores" :single-data="singleData"/>
            </v-flex>
        </v-layout>
        <v-posts-loader :active="postsLoaded ? 'active' : ''"></v-posts-loader>
        <v-flex xs12 class="text-center mt-4 mb-5">
            <v-btn
                v-if="accountData && accountData.end_cursor && !postsLoaded"
                :disabled="postsLoaded"
                @click="loadMorePosts"
                color="#2C4370"
                width="189px"
                height="60px"
                class="buy_btn mb-2"
                dark
                depressed
                rounded
            >
                Load more
            </v-btn>
        </v-flex>
    </v-container>
</template>

<script>
import InstagramCardHeader from "../components/InstagramCardHeader.vue";
import InstagramCardContent from "../components/InstagramCardContent.vue";
import InstagramPostCard from "../components/InstagramPostCard.vue";
import PostsLoader from '../components/PostsLoader.vue';
import {mapActions, mapGetters} from "vuex";
import { getDataBuySingle } from '@/api/biling'
import ShowMessageMixin from "@/mixins/ShowMessageMixin";

export default {
    name: "Instagram",
    mixins: [ShowMessageMixin],
    components: {
        InstagramCardHeader,
        InstagramCardContent,
        InstagramPostCard,
        'v-posts-loader': PostsLoader,
    },

    data: function () {
        return {
            showMessage: false,
            panel: [0],
            selectedAccount: null,
            postsLoaded: false,
            singleData: {},
        }
    },
    created: async function () {
      this.$root.breadcrumbs = [
        {
          text: "Home",
          href: "/dashboard",
        },
        {
          text: "Instagram",
          href: "/instagram",
          icon: "../assets/arrow.svg",
        },
      ];
      this.clearPosts();
      await this.loadSocialNetwork();
      getDataBuySingle()
          .then((data) => {
            console.log(data);
            this.singleData = data.singleData;
          })
          .catch(error => {console.log(error)});
      await this.getInstagramStatistic();
    },
    computed: {
        ...mapGetters('socialnetwork', ['socialNetwork', 'socialNetworkLoaded']),
        ...mapGetters('accounts', ['posts', 'accountData']),
    },
    methods: {
        ...mapActions('socialnetwork', ['loadSocialNetwork']),
        ...mapActions('accounts', ['loadPostsInstagram', 'clearPosts']),
        ...mapActions('scores', ['getInstagramStatistic']),

        loadMorePosts() {
            this.postsLoaded = true;
            this.loadPostsInstagram()
                .then(() => {
                    this.postsLoaded = false;
                })
                .catch(() => this.postsLoaded = false);
        }
    }
};
</script>

<style>
.theme--light.v-expansion-panels .v-expansion-panel {
    background-color: transparent;
}

.v-expansion-panel-header {
    background-color: #fff;
}

.channels_card {
    border-radius: 20px !important;
    overflow: hidden;
}

.channels_box {
    position: relative;
}

.channel {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 0;
    border-radius: 50%;
}

.channel:first-child {
    left: 0;
}

.channel:nth-child(2n) {
    left: 25px;
}

.channel:nth-child(3n) {
    left: 50px;
}

.card_title {
    color: #2c4370;
}

.next_payment {
    font-size: 14px;
    line-height: 17px;
    color: #2C4370;
    text-decoration: none;
}

.payment_date {
    font-size: 20px;
    line-height: 24.38px;
}

.followers_sum {
    color: #172745;
    font-size: 26px;
    line-height: 1em;
}

.followers_title {
    color: #172745;
    font-size: 14px;
    line-height: 17px;
}

.buy_btn {
    text-transform: none !important;
    font-size: 18px !important;
}

.theme--light.v-divider {
    border-color: #c8d3e9 !important;
}

.view_channels_btn {
    text-transform: none !important;
    font-size: 18px !important;
    font-weight: normal !important;
}

.empty_card {
    opacity: 0.6;
    filter: blur(2px);
}

.expand_icon {
    font-size: 50px !important;
    color: #172745 !important;
}

.post_card {
    border-radius: 20px !important;
    overflow: hidden;
}

.post_logo {
    height: 100%;
}

.post_logo img {
    width: 100%;
    display: block;
    max-width: 100%;
    max-height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

.post_info {
    position: relative;
    width: 100%;
    height: 58px;
    background-color: rgba(255, 255, 255, 0.88);
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-top: -58px;
}

.post_comments {
    font-size: 18px;
    color: #172745;
    font-weight: bold;
}

.post_title {
    color: #172745;
    font-size: 18px;
    font-weight: bold;
    background-color: #fff;
    position: relative;
}

.post_btn {
    margin-top: -1px;
    position: relative;
    background-color: #fff;
}

.transition_card {
    background-color: #fff;
    bottom: 0;
    opacity: 1 !important;
    position: absolute;
    width: 100%;
}

.top_transition {
    opacity: 1 !important;
    top: 0;
    height: 58px;
    width: 100%;
    position: absolute;
}

.top_transition .post_info {
    margin-top: 0;
}

.scroller {
    width: 280px;
}

.v-slider--horizontal .v-slider__track-container {
    height: 10px !important;
    border-radius: 56px !important;
    overflow: hidden !important;
    cursor: pointer !important;
}

.v-slider__thumb {
    height: 23px !important;
    width: 23px !important;
    border: 3px solid #fff !important;
    cursor: pointer !important;
}

.v-slider__track-container {
    height: 10px !important;
}

.v-slider__thumb:before {
    left: -10px;
    top: -9px;
}

.file {
    position: relative;
    border: 2px solid #2c4370;
    min-width: 0 !important;
}

.file_tooltip {
    width: 260px;
    white-space: pre-wrap;
    padding: 20px 8px 20px 21px;
    font-size: 12px;
    color: #2c4370;
    background-color: #fff;
    opacity: 1 !important;
    display: none;
    position: absolute;
    z-index: 9999;
    left: -130px;
    top: -90px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.07);
    border-radius: 20px;
}

.file:hover .file_tooltip {
    display: flex;
}
</style>
